import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const DisclaimerPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />

      <div className="pt-24 pb-16">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-[#C5A059] mb-8">
            <ArrowLeft size={16} />
            Back to Home
          </Link>

          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 bg-[#C5A059]/20 rounded-lg flex items-center justify-center">
              <FileText className="text-[#C5A059]" size={24} />
            </div>
            <h1 className="font-manrope font-bold text-3xl text-white">Disclaimer</h1>
          </div>

          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 text-lg mb-8">
              Last updated: February 2026
            </p>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Educational Content Only</h2>
              <p className="text-gray-300">
                The information provided on Digital Gold Gang is for general educational and informational purposes only. 
                All content on this website, including but not limited to market analysis, trading strategies, macro briefs, 
                and educational articles, is provided "as is" without any representations or warranties of any kind.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Not Financial Advice</h2>
              <p className="text-gray-300">
                Nothing on this website constitutes financial advice, investment advice, trading advice, or any other 
                type of professional advice. You should not make any financial, investment, trading, or other decisions 
                based solely on the content provided on this website without conducting your own research and/or consulting 
                with a qualified financial advisor.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Risk Warning</h2>
              <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-6">
                <p className="text-gray-200 font-semibold mb-4">
                  Trading and investing in cryptocurrencies, stocks, and other financial instruments involves substantial 
                  risk of loss and is not suitable for every investor.
                </p>
                <ul className="list-disc list-inside text-gray-300 space-y-2">
                  <li>The value of investments can go down as well as up</li>
                  <li>You may lose some or all of your invested capital</li>
                  <li>Past performance is not indicative of future results</li>
                  <li>Leveraged trading can result in losses exceeding your initial investment</li>
                  <li>Cryptocurrency markets are highly volatile and unregulated in many jurisdictions</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">No Guarantees</h2>
              <p className="text-gray-300">
                We do not guarantee the accuracy, completeness, or timeliness of any information presented. Market 
                conditions change rapidly, and information that was accurate when published may become outdated. 
                Always verify information independently before making any decisions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Third-Party Content</h2>
              <p className="text-gray-300">
                This website may contain links to third-party websites, market data, or other external content. 
                We are not responsible for the accuracy or content of any third-party sources. The inclusion of 
                any link does not imply endorsement by Digital Gold Gang.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Your Responsibility</h2>
              <p className="text-gray-300">
                You are solely responsible for your own investment decisions and any losses you may incur. 
                Before trading or investing, consider your investment objectives, level of experience, and 
                risk appetite. Only invest money you can afford to lose.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Contact</h2>
              <p className="text-gray-300">
                If you have any questions about this disclaimer, please contact us through the community forum 
                or reach out via social media.
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default DisclaimerPage;
